import { withStyles, Theme } from "@material-ui/core/styles";
import { Button } from "@material-ui/core";
import { ButtonProps } from "./button.interface";
import {
  getBackgroundColor,
  getBackgroundHoverColor,
  getBorderColor,
  getColor,
} from "./utils";

export const StyledButton = withStyles((theme: Theme) => ({
  root: {
    fontSize: "1rem",
    boxSizing: "border-box",
    borderRadius: 100,
    padding: "8px 24px",
    border: (props: ButtonProps) => getBorderColor(props),
    color: (props: ButtonProps) => getColor(props, theme),
    backgroundColor: (props: ButtonProps) => getBackgroundColor(props),
    "&:hover": {
      color: (props: ButtonProps) => getColor(props, theme),
      backgroundColor: (props: ButtonProps) => getBackgroundHoverColor(props),
    },
  },
}))(Button);
